module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [(_vm.presence) ? _c('span', {
    class: {
      'active': _vm.online['.value']
    },
    staticStyle: {
      "display": "inline"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.user.firstname)), (_vm.showDeli) ? _c('i', [_vm._v(_vm._s(_vm.deli))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c56b9ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/naming/FirstNameList.vue
// module id = 715
// module chunks = 1